import type { ReactElement, SVGProps } from 'react';

export default function DocumentIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 9.375C10.5 8.75368 11.0016 8.25 11.6203 8.25H20.6297C21.2484 8.25 21.75 8.75368 21.75 9.375C21.75 9.99632 21.2484 10.5 20.6297 10.5H11.6203C11.0016 10.5 10.5 9.99632 10.5 9.375ZM11.6203 21.75C11.0016 21.75 10.5 22.2537 10.5 22.875C10.5 23.4963 11.0016 24 11.6203 24H20.6297C21.2484 24 21.75 23.4963 21.75 22.875C21.75 22.2537 21.2484 21.75 20.6297 21.75H11.6203ZM10.5 16.125C10.5 15.5037 11.0016 15 11.6203 15H20.6297C21.2484 15 21.75 15.5037 21.75 16.125C21.75 16.7463 21.2484 17.25 20.6297 17.25H11.6203C11.0016 17.25 10.5 16.7463 10.5 16.125ZM6 6.375C6 4.51104 7.51104 3 9.375 3H22.875C24.739 3 26.25 4.51104 26.25 6.375L26.25 25.875C26.25 27.739 24.739 29.25 22.875 29.25H9.375C7.51104 29.25 6 27.739 6 25.875V6.375ZM8.25581 6.25998C8.25197 6.29779 8.25 6.33617 8.25 6.375V25.875C8.25 26.4963 8.75368 27 9.375 27H22.875C23.4963 27 24 26.4963 24 25.875L24 6.375C24 5.75368 23.4963 5.25 22.875 5.25L9.375 5.25C8.79251 5.25 8.31342 5.69269 8.25581 6.25998ZM13.1263 33C11.6568 33 10.4067 32.0609 9.94336 30.75H22.8763C25.5687 30.75 27.7513 28.5674 27.7513 25.875V13.4053L29.0128 14.6668C29.6457 15.2998 30.0013 16.1582 30.0013 17.0533V25.875C30.0013 29.8101 26.8113 33 22.8763 33H13.1263Z"
        fill="currentColor"
      />
    </svg>
  );
}
